import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.67 9.32L20.68 5.32C21 5.01 21.09 4.54 20.92 4.12C20.75 3.71 20.35 3.44 19.9 3.44H6V2H4V22H6V15.2H19.9C20.35 15.2 20.74 14.93 20.92 14.52C21.09 14.11 21 13.64 20.68 13.32L16.67 9.32ZM6 13.2V5.44H17.72L13.84 9.32L17.72 13.2H6Z" fill={ fill || 'currentColor' } />
    </svg>
);
